import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CheckboxQuestion } from '@nx-customer-apps/shared/utils';
import { ComponentsModule, slideDown } from '@nx-customer-apps/components';
import { NgClass } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'vp-checkbox',
    templateUrl: './checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [slideDown],
    imports: [NgClass, MatCheckbox, ReactiveFormsModule, ComponentsModule, TranslatePipe]
})
export class CheckboxComponent {
    @Input() question: CheckboxQuestion;
    @Input() form: FormGroup;

    get control(): FormControl {
        return this.form.get((this.question as CheckboxQuestion).key) as FormControl;
    }

    get errorMessage(): string {
        const errorMessage = this.control?.errors?.['message'];
        return errorMessage || (this.question as CheckboxQuestion).defaultErrorMessage;
    }

    get isInvalid(): boolean {
        return this.control?.invalid;
    }

    get isTouched(): boolean {
        return this.control?.touched;
    }
}
